import { createStore } from "vuex";
import authModule from "./auth/index";
import createPersistedState from "vuex-persistedstate";

export default createStore({
  state() {
    return {
      isLoading: false,
      inputVin: "",
      logData: null, // 追加
    };
  },
  getters: {
    getIsLoading(state) {
      return state.isLoading;
    },
  },
  mutations: {
    setIsLoading(state, payload) {
      state.isLoading = payload;
    },
    setInputVin(state, vin) {
      state.inputVin = vin;
    },
    setLogData(state, logData) {
      state.logData = logData;
    },
  },
  actions: {
    setIsLoading(context, payload) {
      context.commit("setIsLoading", payload);
    },
  },
  modules: {
    authModule,
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      paths: ["inputVin"],
    }),
  ],
});
